import { forwardRef } from 'react'
import clsx from 'clsx'
import Image from 'next/image'

import { IData } from './data'

import styles from './course-uniq-points.module.scss'

interface IFooter {
  data: IData[]
  title?: string
  containerModificator?: string
  cardsWrapModificator?: string
  cardModificator?: string
}

const CourseUniqPoints = forwardRef<HTMLDivElement, IFooter>(
  (
    {
      data,
      title = 'В чем уникальность курса?',
      containerModificator,
      cardsWrapModificator,
      cardModificator,
    },
    ref
  ) => {
    return (
      <div
        className={clsx(styles.container, {
          [containerModificator as string]: containerModificator,
        })}
      >
        <h2 className={styles.title} ref={ref}>
          {title}
        </h2>
        <div
          className={clsx(styles.cardsWrap, {
            [cardsWrapModificator as string]: cardsWrapModificator,
          })}
        >
          {data.map((card, index) => (
            <div
              className={clsx(styles.cardWrap, {
                [cardModificator as string]: cardModificator,
              })}
              key={index}
            >
              <Image className={styles.cardIcon} {...card.icon} />

              {card.title && (
                <p className={styles.cardtitle} dangerouslySetInnerHTML={{ __html: card.title }} />
              )}
              <p className={styles.text}>{card.text}</p>
            </div>
          ))}
        </div>
      </div>
    )
  }
)

CourseUniqPoints.displayName = 'CourseUniqPoints'

export default CourseUniqPoints
